import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LangProvider } from "@/i18n";
import { useLenis } from "@/components/useLenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import ServiceDetailPage from "@/pages/ServiceDetail";
import PacksPage from "@/pages/Packs";
import WorksPage from "@/pages/Works";
import CenterPage from "@/pages/Center";
import ZonesPage from "@/pages/Zones";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import BlogPage from "@/pages/Blog";
import BlogPostPage from "@/pages/BlogPost";
import NotFoundPage from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  useLenis();
  return (
    <div className="grain min-h-screen bg-[#050505]">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<ServicesPage />} />
          <Route path="/servicios/:slug" element={<ServiceDetailPage />} />
          <Route path="/packs" element={<PacksPage />} />
          <Route path="/trabajos-realizados" element={<WorksPage />} />
          <Route path="/nuestro-centro" element={<CenterPage />} />
          <Route path="/zonas-de-servicio" element={<ZonesPage />} />
          <Route path="/sobre-ecoglow" element={<AboutPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/ca" element={<HomePage />} />
          <Route path="/ca/servicios" element={<ServicesPage />} />
          <Route path="/ca/servicios/:slug" element={<ServiceDetailPage />} />
          <Route path="/ca/packs" element={<PacksPage />} />
          <Route path="/ca/trabajos-realizados" element={<WorksPage />} />
          <Route path="/ca/nuestro-centro" element={<CenterPage />} />
          <Route path="/ca/zonas-de-servicio" element={<ZonesPage />} />
          <Route path="/ca/sobre-ecoglow" element={<AboutPage />} />
          <Route path="/ca/contacto" element={<ContactPage />} />
          <Route path="/ca/blog" element={<BlogPage />} />
          <Route path="/ca/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
